import Cookies from 'js-cookie';
// routes
import { PATH_AUTH } from '../routes/paths';
// utils
import axios from '../utils/axios';
// import {
//   clearCookies,
//   globalLogout,
//   refreshTokenFn,
//   setSession,
//   setAuthCookies,
// } from '../utils/axios';
// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );


  // console.log('--------------------------------');
  // console.log(base64Url);
  // console.log(base64);
  // console.log(jsonPayload);


  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = async (_idToken: string) => {
  if (!_idToken) {
    return false;
  }

  const decoded = jwtDecode(_idToken);
  const currentTime = Date.now() / 1000;
  const isExpired = !(decoded.exp > currentTime);


  // console.log("decoded");
  // console.log(decoded.exp);
  // console.log("currentTime");
  // console.log(currentTime);
  // const expCookie = Cookies.get('jwt.expires');
  //       let expires: Date;
  // expires = new Date(expCookie);

  // console.log(`isExpired: `);
  // console.log(isExpired);

  if (isExpired) {
    const response = await refreshTokenFn();
    return response;
  }

  setSession(_idToken);
  return true;

};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  console.log(`timeLeft: ${timeLeft} seconds`);

  clearTimeout(expiredTimer);

  // expiredTimer = setTimeout(async () => {
  //   // alert('Token expired');

  //   await refreshTokenFn()
  //   // localStorage.removeItem('accessToken');

  //   // window.location.href = PATH_AUTH.login;
  // }, timeLeft);
};

// ----------------------------------------------------------------------
export const refreshTokenFn = async () => {

  const refreshTokenCookies = Cookies.get('jwt.refresh')
  // console.log("refreshTokenCookies: ");
  // console.log(refreshTokenCookies);
  ;
  if (!refreshTokenCookies) {
    globalLogout();
    return false;
  }

  try {
    const response = await axios.post('/refresh-token', { refreshToken: refreshTokenCookies });

    const { expiresIn, refreshToken, accessToken, idToken } = response.data;

    // console.log(response.data)

    setSession(idToken);
    setAuthCookies({
      idToken,
      accessToken,
      refreshToken,
      expiresIn,
    });
    return true;
  } catch (error) {
    console.log(error);
    globalLogout();
    return false;
  }

}

export const clearCookies = () => {
  Cookies.remove("jwt.id");
  Cookies.remove("jwt.refresh");
  Cookies.remove("jwt.access");
  Cookies.remove("jwt.expires");
  Cookies.remove("userProfileURL");
}


export const getCookies = (cookieName: string, required = true) => {
  const cookieValue = Cookies.get(cookieName);
  if (!cookieValue && required) {
    throw new Error(`${cookieName} not find`);
  }
  return cookieValue;
}

export const setCookies = (cookieName: string, cookieValues: string) => {
  const cookieValue = Cookies.set(cookieName, cookieValues);

  return true;
}


export const isTokenExpired = (token: string) => {
  const decoded = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  const isExpired = !(decoded.exp > currentTime);
  return isExpired;
}



export const getAccessTokenWithRefreshed = async (): Promise<string | undefined> => {
  let _accessToken = getCookies('jwt.access');
  // let _accessToken;
  // // console.log(_accessToken);
  if (_accessToken) {
    //   // const decoded = jwtDecode(_accessToken);
    //   // const currentTime = Date.now() / 1000;
    //   // const isExpired = !(decoded.exp > currentTime);

    //   const isExpired = isTokenExpired(_accessToken);
    //   console.log("isExpired: getAccessToken")
    //   console.log(isExpired)
    //   if (isExpired) {
    // console.log(`isExpired: ${isExpired}`);
    // console.log(isExpired);

    const response = await refreshTokenFn();
    // return response;
    _accessToken = getCookies('jwt.access');
    // console.log("_accessToken")
    // console.log(_accessToken)
    // }

    // console.log(_accessToken)
    return _accessToken;
  }

  return undefined;
}


export const getAccessToken = async (): Promise<string | undefined> => {
  let _accessToken = getCookies('jwt.access');
  // let _accessToken;
  // // console.log(_accessToken);
  if (_accessToken) {
    // const decoded = jwtDecode(_accessToken);
    // const currentTime = Date.now() / 1000;
    // const isExpired = !(decoded.exp > currentTime);

    const isExpired = isTokenExpired(_accessToken);
    //   console.log("isExpired: getAccessToken")
    //   console.log(isExpired)
    if (isExpired) {
      // console.log(`isExpired: ${isExpired}`);
      // console.log(isExpired);

      const response = await refreshTokenFn();
      // return response;
      _accessToken = getCookies('jwt.access');
      // console.log("_accessToken")
      // console.log(_accessToken)
    }

    // console.log(_accessToken)
    return _accessToken;
  }

  return undefined;
}


export const globalLogout = () => {


  clearCookies();
  setSession(null);

}



export const setSession = (idToken: string | null) => {
  if (idToken) {
    // localStorage.setItem('accessToken', accessToken);

    // console.log('accessToken', accessToken);


    axios.defaults.headers.common.Authorization = `Bearer ${idToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(idToken); // ~3 days
    // tokenExpired(exp);
  } else {
    // localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
  }
};

interface cookiesData {
  idToken: string,
  refreshToken: string,
  accessToken: string,
  // username: string,
  // userId: string,
  expiresIn: number,
}

export const setAuthCookies = (data: cookiesData) => {

  // console.log(data)

  const idToken = data.idToken;
  const refreshToken = data.refreshToken;
  const accessToken = data.accessToken;
  // const username = data.username;
  Cookies.set('jwt.id', idToken);

  if (refreshToken)
    Cookies.set('jwt.refresh', refreshToken);


  Cookies.set('jwt.access', accessToken);

  const expiresIn = data.expiresIn;
  const exp = new Date();
  const totalSeconds = exp.getSeconds() + expiresIn;
  exp.setSeconds(totalSeconds);
  Cookies.set('jwt.expires', exp.toISOString());

  // Cookies.set("username", data.username);
  // console.log('JWT cookies set');
}




export const isEmailExist = async (email: any) => {
  try {
    const validEmail = email?.toString();

    const response = await axios.post('is-email-exist', { email });

    // console.log(response);

    const { isExist } = response.data;

    return !isExist;
  } catch (error) {
    // console.log(error);
    return null;
  }
};